import { NgModule } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { LandingLightComponent } from './main/landing-light/landing-light.component';
import { LandingComponent } from './main/landing/landing.component';
import { AboutComponent } from './main/about/about.component';
import { GoalsComponent } from './main/goals/goals.component';
import { AwarenessComponent } from './main/awareness/awareness.component';
import { TrainingComponent } from './main/training/training.component';
import { FaqComponent } from './main/faq/faq.component';
import { ContactUsComponent } from './main/contact-us/contact-us.component';
import { PoliciesTermsComponent } from './main/policies-terms/policies-terms.component';
import { TermsOfUseComponent } from './main/terms-of-use/terms-of-use.component';
import { NewsListComponent } from './main/news-list/news-list.component';
import { NewsDetailsComponent } from './main/news-details/news-details.component';
import { MeterVerificationGuard } from './shared/common/auth/meterVerification.guard';
import { MediaCenterListComponent } from './main/media-center/list/media-center-list.component';
import { MediaCenterDetailComponent } from './main/media-center/detail/media-center-detail.component';
import { KnowledgeBasePublicComponent } from './main/knowledge-base/knowledge-base-public.component';
import { ViewKnowledgeBasePublicComponent } from './main/knowledge-base/view-knowledge-base-public.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            { path: 'landing-full', component: LandingComponent },
            { path: 'home', component: LandingLightComponent },
            { path: 'about', component: AboutComponent },
            { path: 'goals', component: GoalsComponent },
            { path: 'awareness', component: AwarenessComponent },
            { path: 'training', component: TrainingComponent },

            { path: 'faq', component: FaqComponent },
            { path: 'contact-us', component: ContactUsComponent },
            { path: 'policies-terms', component: PoliciesTermsComponent },
            { path: 'terms-of-use', component: TermsOfUseComponent },
            { path: 'new-list', component: NewsListComponent },
            { path: 'new-details', component: NewsDetailsComponent },
            { path: 'media-center/news', component: MediaCenterListComponent, data: { type: 'news' } },
            { path: 'media-center/events', component: MediaCenterListComponent, data: { type: 'events' } },
            { path: 'media-center/library', component: MediaCenterListComponent, data: { type: 'library' } },
            { path: 'media-center/view/:id', component: MediaCenterDetailComponent },
            { path: 'knowledge-base', component: KnowledgeBasePublicComponent },
            { path: 'knowledge-base/view/:id', component: ViewKnowledgeBasePublicComponent },
            {
                path: 'app',
                component: AppComponent,
                canActivate: [AppRouteGuard, MeterVerificationGuard],
                canActivateChild: [AppRouteGuard, MeterVerificationGuard],
                children: [
                    {
                        path: '',
                        children: [
                            { path: 'notifications', component: NotificationsComponent },
                            { path: '', redirectTo: '/app/main/dashboard', pathMatch: 'full' },
                        ],
                    },
                    {
                        path: 'main',
                        loadChildren: () => import('app/main/main.module').then((m) => m.MainModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('app/admin/admin.module').then((m) => m.AdminModule), //Lazy load admin module
                        data: { preload: true },
                        canLoad: [AppRouteGuard],
                    },
                    {
                        path: '**',
                        redirectTo: '',
                    },
                ],
            },
        ]),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
    constructor(private router: Router, private spinnerService: NgxSpinnerService) {
        router.events.subscribe((event) => {
            if (event instanceof RouteConfigLoadStart) {
                spinnerService.show();
            }

            if (event instanceof RouteConfigLoadEnd) {
                spinnerService.hide();
            }

            if (event instanceof NavigationEnd) {
                document.querySelector('meta[property=og\\:url').setAttribute('content', window.location.href);
            }
        });
    }
}
